/** @jsxImportSource @emotion/react */
import React, { useCallback, useMemo, useState } from "react";
import { TreeView, Branch, Item } from "apps/ApplicationPanels/components/tree-view/TreeView";
import { Menu } from "apps/ApplicationPanels/components/context-menu/Menu";
import { MenuItem } from "apps/ApplicationPanels/components/context-menu/MenuItem";
import { Separator } from "apps/ApplicationPanels/components/context-menu/Separator";
import { ApplicationSharedTemplateDto, ApplicationTemplateDto, ApplicationUserTemplateDto } from "../../ApplicationPanel";
import { ApplicationContextMenuActions } from "constants/ApplicationContextMenuActionsConstants";
import { Applications } from "constants/application";
import { getIconById, getThumbnailApplicationIconById, iconsByName } from "components/application-icon/ApplicationIcon";
import { css } from "@emotion/react";
import { useNavigate } from "react-router";
import { ApplicationPanelContext, ApplicationPanelContextType, useApplicationPanel } from "../../contexts/ApplicationPanelContext";
import { useContextMenu } from "../../contexts/ContextMenuContext";
import { useUser } from "contexts/UserContext";
import { deleteJson, postJson, putJson } from "helpers/api";
import { getApplicationDisplayName } from "Utilities";

const styles = {
  icon: css`
    margin-right: 10px;
    width: 16px;
    display: inline-block;
    margin-top: 3px;
    margin-left: 5px;
  `,

  text: css`
    display: inline-block;
    margin-top: 3px;
    line-height: 18px;
    vertical-align: top;
    margin-right: 54px;
  `,

  rpText: css`
    padding: 0;
    vertical-align: top;
    font-size: 12px;
    line-height: 22px;
    color: #3b3b3b;
    font: normal 12px/24px "Segoe UI", Arial, sans-serif;    
  `,

  rpImage: css`
    font-size: 12px;
    line-height: 22px;
    cursor: pointer;
    padding: 3px 3px 3px 9px;
    vertical-align: top;
  `,

  rpGroup: css`
    overflow: auto;
    overflow-x: hidden;
  `,

  rpLink: css`
    background-color: transparent;
    border-bottom: 0;
    display: block;
    cursor: pointer;
    text-decoration: none;
    overflow: hidden;
    font-size: 12px;
    line-height: 22px;
    color: #3b3b3b;
    font: normal 12px/24px "Segoe UI", Arial, sans-serif;

    &:hover {
      background-image: url("data:image/png;base64,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");
      background-repeat: no-repeat;
      background-position: 0px -199px;
      border-color: #c28b31 #c2a34c;
      cursor: pointer;
    }
  `,

  rpOut: css`
    border-bottom: 0;
    margin-right: 3px;
  `,

  rpExpandHandle: css`
    font-size: 12px;
    line-height: 22px;
  `,

  emsListBox: css`
    border: 1px solid #9aa0a6;
    background: #fff;
    margin-left: 10px;
    margin-right: 10px;
  `,

  rlbGroup: css`
    font: normal 12px/24px "Segoe UI", Arial, sans-serif;
    outline: none;
  `,

  rlbList: css`
    list-style: none outside;
    position: relative;
    margin: 0;
    padding: 0;
    height: 100%;
  `,

  rlbItem: css`
    padding: 2px 5px;
    white-space: nowrap;
    line-height: 18px;
    font-size: 12px;
    &:hover {
      background-color: #fae185;
      color: #000;
      cursor: pointer;
    }
  `,

  tlbText: css`
    vertical-align: middle;
  `
};

const buildTemplateTreeView = ( templateDataSource: Array<ApplicationUserTemplateDto> ): Branch => {
  const branchesAndItems: Record<number, Branch> = {};
  const templateImage = <img alt="app" src={ getIconById( "template" ) } />;
  const folderImage = <img alt="app" src={ getIconById( "folder" ) } />;

  branchesAndItems[ 0 ] = { id: 0, canRename: false, name: "Templates", icon: templateImage, branches: [] };

  for ( const template of templateDataSource ) {
    let branchOrItem: Branch = branchesAndItems[ template.id ];
    if ( branchOrItem ) {
      branchOrItem.name = template.name;
    } else {
      branchOrItem = { id: template.id, canRename: template.id !== 0, name: template.name, icon: template.isFolder ? folderImage : undefined };
      branchesAndItems[ template.id ] = branchOrItem;
    }

    //branch.tooltip = template.name; // TODO:

    if ( template.parentId != null ) {
      let parent = branchesAndItems[ template.parentId ];
      if ( !parent ) {
        parent = { id: template.parentId, canRename: template.parentId !== 0, name: "AWAITING LOAD", icon: template.isFolder ? folderImage : undefined };
        branchesAndItems[ template.parentId ] = parent;
      }

      if ( template.isFolder ) {
        parent.branches = parent.branches || [];
        parent.branches.push( branchOrItem );
      } else {
        parent.items = parent.items || [];
        parent.items.push( branchOrItem );
      }
    }
  }
  return branchesAndItems[ 0 ];
};

const buildSharedTreeView = ( sharedDataSource: Array<ApplicationSharedTemplateDto> ): Branch | null => {
  if ( sharedDataSource.length === 0 ) return null;

  const root: Branch = { id: -2, name: "Shared", canRename: false, branches: [], icon: <img alt="shared" src={ getIconById( "shared" ) } /> };

  for ( const byOwner of sharedDataSource ) {
    const userBranch: Branch = { id: byOwner.ownerId, name: byOwner.ownerName, canRename: false, items: [], icon: <img alt="user" src={ getIconById( "person" ) } /> };
    for ( const template of byOwner.templates ) {
      const item: Item = { id: template.id, name: template.name, canRename: false };
      userBranch.items?.push( item );
    }
    root.branches?.push( userBranch );
  }

  return root;
};

const CopyTo = ( { itemId, applicationId, isMenuItemDisabled, onContextMenuCopyTo }: { itemId: number; applicationId: number; isMenuItemDisabled: boolean; onContextMenuCopyTo: ( applicationId: number, itemId: number ) => void; } ) => {
  const { availableApplicationIds, applicationNames } = useApplicationPanel();

  const onClickHandler = useCallback( () => {
    onContextMenuCopyTo( applicationId, itemId );
  }, [ applicationId, itemId, onContextMenuCopyTo ] );

  if ( !availableApplicationIds.includes( applicationId ) ) return <></>;

  const applicationName = applicationNames[ applicationId ];

  return <MenuItem disabled={ isMenuItemDisabled } onClick={ onClickHandler } label={
    <>
      <span css={ styles.icon }><img alt={ applicationName } src={ getThumbnailApplicationIconById( applicationId ) } /></span>
      <span css={ styles.text }>{ applicationName }</span>
    </> } />;
};

const ContextFooter = ( { itemId, includeTopBorder, isMenuItemDisabled, onContextMenuCopyTo }: { itemId: number; includeTopBorder: boolean; isMenuItemDisabled: boolean; onContextMenuCopyTo: ( applicationId: number, itemId: number ) => void; } ) => <>
  <Separator label={ "Copy selections to:" } topBorder={ includeTopBorder } />
  <CopyTo itemId={ itemId } applicationId={ Applications.ProgramFinder }           /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.DistributorFinder }       /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.ProgramSearch }           /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.ProgramPerformance }      /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.ProgramRanking }          /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.ProgramAverageTimeSpent } /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.ChannelView }             /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.QuarterHour }             /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.RevenueEstimator }        /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
  <CopyTo itemId={ itemId } applicationId={ Applications.WeeklyChannelView }       /**/ isMenuItemDisabled={ isMenuItemDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
</>;

const ContextMenuTemplates = ( { applicationPanel, itemId, itemName, nodeType, onContextMenuRename, onContextMenuDelete, onContextMenuNewFolder, onContextMenuCopyTo }: { applicationPanel: ApplicationPanelContextType; itemId: number; itemName: string; nodeType: string; onContextMenuDelete: ( itemId: number ) => void; onContextMenuNewFolder: ( itemId: number ) => void; onContextMenuRename: ( itemId: number ) => void; onContextMenuCopyTo: ( applicationId: number, itemId: number ) => void; } ) => {
  const isNewFolderDisabled = ( nodeType !== "branch" );
  const isRenameDisabled = ( nodeType === "branch" && itemId === 0 );
  const isDeleteDisabled = ( nodeType === "branch" && itemId === 0 );
  const isCopyDisabled = ( nodeType === "branch" );

  return ( <>
    <ApplicationPanelContext.Provider value={ applicationPanel }>
      <Menu>
        <MenuItem onClick={ () => onContextMenuRename( itemId ) }    /**/ disabled={ isRenameDisabled } label={ <><span css={ styles.icon }><img alt="rename" src={ iconsByName.rename } /></span><span css={ styles.text }>Rename <span css={ css`line-height: 16px; vertical-align: top` }>'{ itemName }`</span></span></> } />
        <MenuItem onClick={ () => onContextMenuNewFolder( itemId ) } /**/ disabled={ isNewFolderDisabled } label={ <><span css={ styles.icon }><img alt="new folder" src={ iconsByName.newfolder } /></span><span css={ styles.text }>New folder</span></> } />
        <MenuItem onClick={ () => onContextMenuDelete( itemId ) }    /**/ disabled={ isDeleteDisabled } label={ <><span css={ styles.icon }><img alt="delete" src={ iconsByName.delete } /></span><span css={ styles.text }>Delete <span css={ css`line-height: 16px; vertical-align: top` }>'{ itemName }`</span></span></> } />
        <ContextFooter itemId={ itemId } includeTopBorder={ true } isMenuItemDisabled={ isCopyDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
      </Menu>
    </ApplicationPanelContext.Provider>
  </> );
};

const ContextMenuShared = ( { applicationPanel, itemId, itemName, nodeType, onContextMenuDelete, onContextMenuCopyTo }: { applicationPanel: ApplicationPanelContextType; itemId: number; itemName: string; nodeType: string; onContextMenuDelete: ( itemId: number ) => void; onContextMenuCopyTo: ( applicationId: number, itemId: number ) => void; } ) => {
  const isDeleteDisabled = nodeType === "branch";
  const isCopyDisabled = nodeType === "branch";

  return ( <>
    <ApplicationPanelContext.Provider value={ applicationPanel }>
      <Menu>
        <MenuItem onClick={ () => null } disabled={ true } label={ <><span css={ styles.icon }><img alt="rename" src={ iconsByName.rename } /></span><span css={ styles.text }>Rename <span css={ css`line-height: 16px; vertical-align: top` }>'{ itemName }`</span></span></> } />
        <MenuItem onClick={ () => null } disabled={ true } label={ <><span css={ styles.icon }><img alt="new folder" src={ iconsByName.newfolder } /></span><span css={ styles.text }>New folder</span></> } />
        <MenuItem data={ { actionName: ApplicationContextMenuActions.Delete } } onClick={ () => onContextMenuDelete( itemId ) } disabled={ isDeleteDisabled } label={ <><span css={ styles.icon }><img alt="delete" src={ iconsByName.delete } /></span><span css={ styles.text }>Delete <span css={ css`line-height: 16px; vertical-align: top` }>'{ itemName }`</span></span></> } />
        <ContextFooter itemId={ itemId } includeTopBorder={ true } isMenuItemDisabled={ isCopyDisabled } onContextMenuCopyTo={ onContextMenuCopyTo } />
      </Menu>
    </ApplicationPanelContext.Provider>
  </> );
};

const ContextMenuHistory = ( { applicationPanel, itemId, onContextMenuCopyTo }: { applicationPanel: ApplicationPanelContextType; itemId: number; onContextMenuCopyTo: ( applicationId: number, itemId: number ) => void; } ) => <>
  <ApplicationPanelContext.Provider value={ applicationPanel }>
    <Menu>
      <ContextFooter itemId={ itemId } includeTopBorder={ false } isMenuItemDisabled={ false } onContextMenuCopyTo={ onContextMenuCopyTo } />
    </Menu>
  </ApplicationPanelContext.Provider>
</>;

const HistoryList = ( { historyDataSource, onItemClick, onContextMenu }: { historyDataSource: Array<ApplicationTemplateDto>; onItemClick: ( itemId: number ) => void; onContextMenu: ( e: React.MouseEvent, id: number, name: string, nodeType: string ) => void; } ) => {
  // TODO: use the below
  //const selectedTemplateNode = useSelectedTemplateNode();

  return ( <>
    <div css={ styles.emsListBox }>
      <div css={ styles.rlbGroup }>
        <ul css={ styles.rlbList }>
          {/* TODO: support selected */ }
          { historyDataSource.map( ( m, i ) => (
            <li key={ i } css={ styles.rlbItem } data-value={ m.id } onClick={ () => onItemClick( m.id ) } onContextMenu={ ( e ) => onContextMenu( e, m.id, m.name, "" ) } >
              <span css={ styles.tlbText }>{ m.name }</span>
            </li> ) ) }
        </ul>
      </div>
    </div>
  </> );
};

export const ApplicationPanel = ( { applicationId, templateDataSource, sharedDataSource, historyDataSource, availableApplicationIds, setActiveApplication }: { applicationId: number; templateDataSource: Array<ApplicationUserTemplateDto>; sharedDataSource: Array<ApplicationSharedTemplateDto>; historyDataSource: Array<ApplicationTemplateDto>; availableApplicationIds: Array<number>; setActiveApplication( applicationPanelIndex: number ): void; } ): JSX.Element => {
  const [ selectedNodeId, setSelectedNodeId ] = useState<number | undefined>( undefined );
  const [ renamingNodeId, setRenamingNodeId ] = useState<number | undefined>( undefined );
  const applicationNames = useMemo( () => {
    const result: Record<number, string> = {};
    for ( const id of availableApplicationIds ) {
      result[ id ] = getApplicationDisplayName( id );
    }

    result[ Applications.AvailableData ] = getApplicationDisplayName( Applications.AvailableData );

    return result;
  }, [ availableApplicationIds ] );

  return ( <>
    <ApplicationPanelContext.Provider value={ { selectedNodeId, setSelectedNodeId, renamingNodeId, setRenamingNodeId, availableApplicationIds, applicationNames } }>
      <ApplicationPanelInner applicationId={ applicationId } templateDataSource={ templateDataSource } sharedDataSource={ sharedDataSource } historyDataSource={ historyDataSource } setActiveApplication={ setActiveApplication } />
    </ApplicationPanelContext.Provider>
  </> );
};

export const ApplicationPanelInner = ( { applicationId, templateDataSource, sharedDataSource, historyDataSource, setActiveApplication }: { applicationId: number; templateDataSource: Array<ApplicationUserTemplateDto>; sharedDataSource: Array<ApplicationSharedTemplateDto>; historyDataSource: Array<ApplicationTemplateDto>; setActiveApplication( applicationPanelIndex: number, itemId?: number ): void; } ): JSX.Element => {
  const user = useUser();
  const navigate = useNavigate();
  const contextMenu = useContextMenu();
  const applicationPanel = useApplicationPanel();
  const templateTreeViewRoot = useMemo( () => buildTemplateTreeView( templateDataSource ), [ templateDataSource ] );
  const sharedTreeViewRoot = useMemo( () => buildSharedTreeView( sharedDataSource ), [ sharedDataSource ] );

  const switchToApplicationAndTemplate = useCallback( async ( applicationId: number, itemId: number ) => {
    switch ( applicationId ) {
      case Applications.ProgramFinder: navigate( `/ProgramFinder/${ itemId }` ); break;
      case Applications.ProgramSearch: navigate( `/ProgramSearch/${ itemId }` ); break;
      case Applications.QuarterHour: navigate( `/QuarterHour/${ itemId }` ); break;
      case Applications.ProgramPerformance: navigate( `/ProgramPerformance/${ itemId }` ); break;
      case Applications.ProgramRanking: navigate( `/ProgramRanking/${ itemId }` ); break;
      case Applications.ProgramAverageTimeSpent: navigate( `/ProgramAverageTimeSpent/${ itemId }` ); break;
      case Applications.DistributorFinder: navigate( `/DistributorFinder/${ itemId }` ); break;
      case Applications.ChannelView: navigate( `/ChannelView/${ itemId }` ); break;
      case Applications.RevenueEstimator: navigate( `/RevenueEstimator/${ itemId }` ); break;
      case Applications.WeeklyChannelView: navigate( `/WeeklyChannelView/${ itemId }` ); break;
      case Applications.AvailableData: navigate( `/AvailableData/${ itemId }` ); break;
      default: console.error( "unknown application type" );
    }
  }, [ navigate ] );

  const onContextMenuCopyTo = useCallback( async ( applicationId: number, itemId: number ) => {
    contextMenu.hide();
    await switchToApplicationAndTemplate( applicationId, itemId );
  }, [ contextMenu, switchToApplicationAndTemplate ] );

  const onContextMenuRenameStart = useCallback( async ( itemId: number ) => {
    contextMenu.hide();
    applicationPanel.setRenamingNodeId( itemId );
  }, [ applicationPanel, contextMenu ] );

  const onContextMenuNewFolder = useCallback( async ( itemId: number ) => {
    console.log( `New folder item ${ itemId }` );

    const newItemId = ( await postJson<{ itemId: number; }>( `/UserTemplate/${ applicationId }/${ itemId }`, user.userId, user.token ) ).itemId;

    contextMenu.hide();
    applicationPanel.setRenamingNodeId( newItemId );
  }, [ applicationId, applicationPanel, contextMenu, user.token, user.userId ] );

  const onContextMenuDelete = useCallback( async ( itemId: number ) => {
    console.log( `Delete item ${ itemId }` );

    await deleteJson( `/UserTemplate/${ applicationId }/${ itemId }`, user.userId, user.token );

    contextMenu.hide();
  }, [ applicationId, contextMenu, user.token, user.userId ] );

  const templateTreeViewContextMenuClick = useCallback( ( e: React.MouseEvent, itemId: number, itemName: string, nodeType: string ) => {
    e.preventDefault();
    e.stopPropagation();
    contextMenu.show( e.clientX, e.clientY, <ContextMenuTemplates applicationPanel={ applicationPanel } itemId={ itemId } itemName={ itemName } nodeType={ nodeType } onContextMenuDelete={ onContextMenuDelete } onContextMenuNewFolder={ onContextMenuNewFolder } onContextMenuRename={ onContextMenuRenameStart } onContextMenuCopyTo={ onContextMenuCopyTo } /> );
  }, [ applicationPanel, contextMenu, onContextMenuCopyTo, onContextMenuDelete, onContextMenuNewFolder, onContextMenuRenameStart ] );

  const sharedTreeViewContextMenuClick = useCallback( ( e: React.MouseEvent, itemId: number, itemName: string, nodeType: string ) => {
    e.preventDefault();
    e.stopPropagation();
    contextMenu.show( e.clientX, e.clientY, <ContextMenuShared applicationPanel={ applicationPanel } itemId={ itemId } itemName={ itemName } nodeType={ nodeType } onContextMenuDelete={ onContextMenuDelete } onContextMenuCopyTo={ onContextMenuCopyTo } /> );
  }, [ applicationPanel, contextMenu, onContextMenuCopyTo, onContextMenuDelete ] );

  const historyContextMenuClick = useCallback( ( e: React.MouseEvent, itemId: number, itemName: string, nodeType: string ) => {
    e.preventDefault();
    e.stopPropagation();
    contextMenu.show( e.clientX, e.clientY, <ContextMenuHistory applicationPanel={ applicationPanel } itemId={ itemId } onContextMenuCopyTo={ onContextMenuCopyTo } /> );
  }, [ applicationPanel, contextMenu, onContextMenuCopyTo ] );

  const onItemClick = useCallback( ( itemId: number ) => {
    switchToApplicationAndTemplate( applicationId, itemId );
  }, [ applicationId, switchToApplicationAndTemplate ] );

  const onItemRename = useCallback( async ( itemId: number, name: string ) => {
    console.log( `Rename item ${ itemId } to ${ name }` );

    await putJson( `/UserTemplate/${ applicationId }/${ itemId }/name`, user.userId, user.token, { name } );
  }, [ applicationId, user.token, user.userId ] );

  const onItemMove = useCallback( async ( itemId: number, parentId: number ) => {
    console.log( `Move item ${ itemId } to parent ${ parentId }` );

    await putJson( `/UserTemplate/${ applicationId }/${ itemId }/parentId`, user.userId, user.token, { parentId } );
  }, [ applicationId, user.token, user.userId ] );

  return ( <>
    <div css={ styles.rpGroup }>
      <button type="button" css={ [ css`border: none; text-align: left; width: 100%; border: none;`, styles.rpLink ] } onClick={ () => { onItemClick( 0 ); applicationPanel.setSelectedNodeId( undefined ); } } >
        <span css={ styles.rpOut }>
          <img alt="new" src={ getThumbnailApplicationIconById( applicationId ) } css={ styles.rpImage } />
          <span css={ styles.rpExpandHandle }></span>
          <span css={ styles.rpText }>New</span>
        </span>
      </button>
    </div>

    <TreeView root={ templateTreeViewRoot } onRename={ onItemRename } onMove={ onItemMove } onItemClick={ onItemClick } onContextMenu={ templateTreeViewContextMenuClick } />

    { sharedTreeViewRoot && <TreeView root={ sharedTreeViewRoot } onRename={ undefined } onMove={ undefined } onItemClick={ onItemClick } onContextMenu={ sharedTreeViewContextMenuClick } /> }

    { historyDataSource.length > 0 && <>
      <hr css={ css`width: 95%` } />
      <div css={ css`padding-bottom: 10px;` }>
        <div>
          <img alt="History" src={ iconsByName.history } css={ styles.rpImage } />
          <span css={ styles.rpText }>History</span>
        </div>
        <HistoryList historyDataSource={ historyDataSource } onItemClick={ onItemClick } onContextMenu={ historyContextMenuClick } />
      </div>
    </> }
  </> );
};
